import React from 'react';
import { DEFAULT_THEME_COLOR } from 'appenv';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { BoothTaxonomy } from 'models/cms/boothTaxonomies';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';

const CustomCheckbox = ({ color, children, ...props }: any) => {
  const Custom = withStyles({
    root: {
      width: '42px',
      padding: '0 9px',
      verticalAlign: 'top',
      marginRight: '7px',
      color: '#A2AAB3',
      '&$checked': {
        color,
      },
    },
    checked: {},
  })(Checkbox);
  return <Custom {...props as any}>{children as any}</Custom>;
};

const StyledFilterOptionContainer = styled.div<{ selected?: boolean }>`
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 0;
  transition: all 0.1s;
  display: block;
  color: ${({ selected }) => (selected && (DEFAULT_THEME_COLOR || '#0CA58B'))};

  &:hover {
    color: ${DEFAULT_THEME_COLOR || '#0CA58B'};
  }
`;

const StyledLabel = styled.label`
  display: inline-block;
  width: calc(100% - 50px);
  font-size: 14px;
  line-height: 20px;
  color: #484848;
  cursor: pointer;
`;

export interface FilterCheckboxOptionProps {
  filter: Omit<BoothTaxonomy, 'subcategories'>;
  selectedFilter: string[];
  setSelectedFilter: (updater: string[] | ((filter: string[]) => string[])) => null;
}

const FilterCheckboxOption: React.FC<FilterCheckboxOptionProps> = ({
  filter,
  selectedFilter,
  setSelectedFilter,
}: FilterCheckboxOptionProps) => {
  const locale = useSelector(selectLocale);
  const isSelected = !!selectedFilter.find((it) => it === filter.id);
  const displayLabel = filter.name[locale] || Object.values(filter.name).filter((it) => it)[0];
  const { themeColor } = useSelector((s: any) => s.eventConfigs);

  const onCustomCheckboxClick = () => {
    setSelectedFilter((prev) => {
      const index = prev.findIndex((it) => it === filter.id);
      if (index === -1) return [...Array.from(new Set([...prev, filter.id]))];
      return [...prev.slice(0, index), ...prev.slice(index + 1)];
    });
  };

  return (
    <StyledFilterOptionContainer>
      <CustomCheckbox
        id={filter.id}
        onClick={onCustomCheckboxClick}
        checked={isSelected}
        color={themeColor || DEFAULT_THEME_COLOR}
      />
      <StyledLabel htmlFor={filter.id}>{displayLabel}</StyledLabel>
    </StyledFilterOptionContainer>
  );
};

export default FilterCheckboxOption;
